<template>
  <vue-scroll>
    <el-drawer
      title="Respuestas"
      :visible="openDetail"
      size="60%"
      :before-close="CloseTransactionDetail"
    >
      <div class="tag-group" style="margin: 20px">
        <h2 style="color: rgb(116, 146, 211)">Pregunta: {{ label }}</h2>
      </div>
      <RabbeyTable3
        :columns="columnsanswers"
        :data="itemsAnswers"
        style="margin: 20px"
      />
      <div class="flex">
        <div class="m-30">
          <h3>Respuestas: {{ totalAnswers }}</h3>
        </div>
        <div class="m-30">
          <h3>Porcentaje: {{ porsentaje }}</h3>
        </div>
      </div>
    </el-drawer>
    <el-row>
      <el-select
        v-model="FormSurvey"
        placeholder="Selecciona la encuesta"
        @change="hanldeSelection"
      >
        <el-option
          v-for="item in Surveys"
          :key="item.No_FormReal"
          :label="item.Nombre"
          :value="item.No_FormReal"
        >
        </el-option>
      </el-select>
      <div style="display: flex; position: relative; float: right">
        <DepartmentSelector
          v-if="IsInRoles([roles.GerenteRRHH, roles.CEO, roles.SuperUsuario])"
          @selection-change="handleChangeDepartment"
          @onDirectionChange="handleChangeDirection"
          :onlyDepartment="false"
          :directionIdProp="directionId"
        />
      </div>
    </el-row>

    <RabbeyTable3
      :columns="columns"
      :data="items"
      style="margin: 20px"
      :actions="actions"
      @rtable-push-action="handlePushAction"
    />
  </vue-scroll>
</template>

<script>
import RabbeyTable3 from "@/components/RabbeyTable3.vue";
import InteractionDetailsHyperLink from "@/components/functionals/InteractionDetailsHyperLink.vue";
import ImagePerson from "@/components/functionals/ImagePerson.vue";
import DepartmentSelector from "@/components/Company/DepartmentSelector.vue";

export default {
  props: {
    module: {
      type: String,
      default: null,
      required: false
    }
  },
  name: "ReportSurvey",
  components: {
    RabbeyTable3,
    DepartmentSelector
  },
  data() {
    return {
      FormSurvey: "",
      items: [],
      name: "",
      label: "",
      Formid: "",
      itemsAnswers: [],
      openDetail: false,
      dataforms: [],
      typeplataforma: "",
      Surveys: [],
      Mes: "",
      QuestinId: 0,
      directionId: 0,
      departmentId: 0,
      porsentaje: 0,
      totalAnswers: 0,
      columns: [
        {
          prop: "question",
          label: "Pregunta",
          fixed: true,
          minWidth: 300
        },
        {
          prop: "January",
          label: "Enero",
          minWidth: 100,
          formatter: InteractionDetailsHyperLink,
          attrs: {
            openDrawer: this.OpenSalesDitails
          }
        },
        {
          prop: "February",
          label: "Febrero",
          minWidth: 100,
          formatter: InteractionDetailsHyperLink,
          attrs: {
            openDrawer: this.OpenSalesDitails
          }
        },
        {
          prop: "March",
          label: "Marzo",
          width: 100,
          formatter: InteractionDetailsHyperLink,
          attrs: {
            openDrawer: this.OpenSalesDitails
          }
        },
        {
          prop: "April",
          label: "Abril",
          width: 100,
          formatter: InteractionDetailsHyperLink,
          attrs: {
            openDrawer: this.OpenSalesDitails
          }
        },
        {
          prop: "May",
          label: "Mayo",
          width: 100,
          formatter: InteractionDetailsHyperLink,
          attrs: {
            openDrawer: this.OpenSalesDitails
          }
        },
        {
          prop: "June",
          label: "Junio",
          width: 100,
          formatter: InteractionDetailsHyperLink,
          attrs: {
            openDrawer: this.OpenSalesDitails
          }
        },
        {
          prop: "July",
          label: "Julio",
          width: 100,
          formatter: InteractionDetailsHyperLink,
          attrs: {
            openDrawer: this.OpenSalesDitails
          }
        },
        {
          prop: "August",
          label: "Agosto",
          width: 100,
          formatter: InteractionDetailsHyperLink,
          attrs: {
            openDrawer: this.OpenSalesDitails
          }
        },
        {
          prop: "September",
          label: "Septiembre",
          width: 100,
          formatter: InteractionDetailsHyperLink,
          attrs: {
            openDrawer: this.OpenSalesDitails
          }
        },
        {
          prop: "October",
          label: "Octubre",
          width: 100,
          formatter: InteractionDetailsHyperLink,
          attrs: {
            openDrawer: this.OpenSalesDitails
          }
        },
        {
          prop: "November",
          label: "Noviembre",
          width: 100,
          formatter: InteractionDetailsHyperLink,
          attrs: {
            openDrawer: this.OpenSalesDitails
          }
        },
        {
          prop: "December",
          label: "Diciembre",
          width: 100,
          formatter: InteractionDetailsHyperLink,
          attrs: {
            openDrawer: this.OpenSalesDitails
          }
        }
      ],
      columnmagynet: [
        {
          prop: "Empleado",
          label: "Usuario",
          formatter: ImagePerson,
          attrs: {
            imgKey: "ImageEmployees"
          },
          minWidth: 50
        },
        {
          prop: "Deparment",
          label: "Departamento",
          minWidth: 50
        },
        {
          prop: "answersValue",
          label: "Respuesta",
          minWidth: 200
        }
      ],
      columnmagynetprosiento: [
        {
          prop: "Empleado",
          label: "Usuario",
          formatter: ImagePerson,
          attrs: {
            imgKey: "ImageEmployees"
          },
          minWidth: 50
        },
        {
          prop: "Deparment",
          label: "Departamento",
          minWidth: 50
        },
        {
          prop: "answersValue",
          label: "Respuesta",
          minWidth: 100
        },
        {
          prop: "answersValue2",
          label: "Que debemos mejorar",
          minWidth: 100
        }
      ],
      columnNcf: [
        {
          prop: "Empresa",
          label: "Empresa",
          minWidth: 100
        },
        // {
        //   prop: "Deparment",
        //   label:"Departamento",
        //   minWidth: 100
        // },
        {
          prop: "answersValue",
          label: "Respuesta",
          minWidth: 100
        }
      ],
      columnsMagy: [
        {
          prop: "Usuario",
          label: "Usuario",
          minWidth: 100
        },
        {
          prop: "Empresa",
          label: "Empresa",
          minWidth: 100
        },
        {
          prop: "answersValue",
          label: "Respuesta",
          minWidth: 100
        }
      ]
    };
  },

  // beforeRouteEnter(to, from){
  //   // console.log(to,from)

  //   // this.switchmethod()
  //   // this.getForms();
  //   // this.GetAnswers()

  // },
  // beforeRouteEnter(to, from){
  //   console.log(to,from)

  //   console.log("beforeRouteEnter")

  // },

  created() {
    this.switchmethod();

    if (
      !this.IsInRoles([
        this.roles.GerenteRRHH,
        this.roles.CEO,
        this.roles.SuperUsuario
      ])
    ) {
      this.directionId = this.currentUser.DireccionID;
      this.departmentId = this.currentUser.DepartamentID;
    }
    this.getForms();
    this.GetAnswers();
  },
  methods: {
    getquestionsForms() {
      this.$http
        .get(
          `/api/survey/GetAnswerByMonth?year=${2023}&IdSurvey=${
            this.Formid
          }&directionId=${this.directionId}&departmentId=${this.departmentId}`
        )
        .then((data) => {
          this.items = data.data;
        });
    },
    getForms() {
      this.$http
        .get(
          `/api/survey/GetSurveyFormByPlataform?typepaltaforma=${this.typeplataforma}`
        )
        .then((resp) => {
          this.Surveys = resp.data;
          if (this.Surveys.length > 0) {
            this.FormSurvey = this.Surveys[0].Nombre;
            this.Formid = this.Surveys[0].No_FormReal;
            this.getquestionsForms();
          }
        });
    },
    OpenSalesDitails(row, column) {
      this.plataforma = row.TypeForm;
      this.openDetail = true;
      this.QuestinId = row.questionid;
      this.label = row.question;
      this.Mes = column;
      this.GetAnswers();
    },

    GetAnswers() {
      const params = {
        questionId: this.QuestinId,
        createdatmes: this.Mes
      };

      this.$http
        .get(
          `/api/survey/GetAnswer?questionId=${params.questionId}&createdatmes=${params.createdatmes}&typepaltaforma=${this.typeplataforma}&TypeForm=${this.plataforma}&directionId=${this.directionId}&departmentId=${this.departmentId}`
        )
        .then((resp) => {
          this.itemsAnswers = resp.data;
          this.totalAnswers = this.itemsAnswers.length;

          if (this.plataforma == "Magynet" && params.questionId == 0) {
            this.columnsanswers = this.columnmagynetprosiento;
          } else if (this.plataforma == "Magynet") {
            this.columnsanswers = this.columnmagynet;
          } else if (this.plataforma == "Magypago") {
            this.columnsanswers = this.columnsMagy;
          } else {
            this.columnsanswers = this.columnNcf;
          }

          let dataResponse = resp.data;
          let responsesNumbers = dataResponse.map((r) =>
            this.ExtraerNumber(r.answersValue)
          );
          let totalResponse = responsesNumbers.length;
          let sumResponses = responsesNumbers.reduce((a, b) => a + b, 0);
          let maximoPosible = totalResponse * 5;
          let porsentajeFinal =
            totalResponse > 0
              ? ((sumResponses / maximoPosible) * 100).toFixed(1)
              : 0;
          this.porsentaje = porsentajeFinal;
        });
    },
    CloseTransactionDetail() {
      this.openDetail = false;
    },
    handleChangeDepartment(DepartmentID) {
      this.departmentId = DepartmentID;
      this.getquestionsForms();
    },
    handleChangeDirection(directionId) {
      this.directionId = directionId;
      this.departmentId = null;
      this.getquestionsForms();
    },
    hanldeSelection(option) {
      this.Formid = option;
      this.getquestionsForms();
    },
    switchmethod() {
      switch (this.$router.currentRoute.name) {
        case "employeesFinances-reportsurvey":
          this.typeplataforma = "Empleados";
          this.directionId = 46;
          this.departmentId = null;
          break;

        case "employeesTechnology-reportsurvey":
          this.typeplataforma = "Empleados";
          this.directionId = 42;
          this.departmentId = null;

          break;
        case "employeestechnical-reportsurvey":
          this.typeplataforma = "Empleados";
          this.directionId = 49;
          this.departmentId = null;

          break;

        case "customers-reportsurvey":
          this.typeplataforma = "";
          break;
        case "employeesSales-reportsurvey":
          this.typeplataforma = "Empleados";
          this.directionId = 41;
          this.departmentId = null;
          break;

        default:
          this.typeplataforma = "Empleados";

          break;
      }
    },
    ExtraerNumber(value) {
      const match = value.toString().match(/\d+/);
      return match ? parseInt(match[0]) : 0;
    }
  },
  watch: {
    module() {
      console.log(this.name);
    }
  }
};
</script>

<style></style>
